"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusPreviousSiblingOf = exports.focusNextSiblingOf = exports.focusLastSiblingOf = exports.focusFirstSiblingOf = exports.getSiblingButtons = exports.getClosestAccordion = void 0;
function getClosestAccordion(el) {
    return (el &&
        (el.matches('[data-accordion-component="Accordion"]')
            ? el
            : getClosestAccordion(el.parentElement)));
}
exports.getClosestAccordion = getClosestAccordion;
function getSiblingButtons(item) {
    var parentAccordion = getClosestAccordion(item);
    return (parentAccordion &&
        Array.from(parentAccordion.querySelectorAll('[data-accordion-component="AccordionItemButton"]')));
}
exports.getSiblingButtons = getSiblingButtons;
function focusFirstSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var first = siblings[0];
    if (first) {
        first.focus();
    }
}
exports.focusFirstSiblingOf = focusFirstSiblingOf;
function focusLastSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var last = siblings[siblings.length - 1];
    if (last) {
        last.focus();
    }
}
exports.focusLastSiblingOf = focusLastSiblingOf;
function focusNextSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var currentIndex = siblings.indexOf(item);
    if (currentIndex !== -1) {
        var next = siblings[currentIndex + 1];
        if (next) {
            next.focus();
        }
    }
}
exports.focusNextSiblingOf = focusNextSiblingOf;
function focusPreviousSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var currentIndex = siblings.indexOf(item);
    if (currentIndex !== -1) {
        var previous = siblings[currentIndex - 1];
        if (previous) {
            previous.focus();
        }
    }
}
exports.focusPreviousSiblingOf = focusPreviousSiblingOf;
//# sourceMappingURL=focus.js.map